module.exports = [{
  code: 0,
  name: 'created',
  title: 'créée',
  description: 'La commande a été créée mais pas encore vérifiée'
},{
  name: 'verified',
  title: 'vérifiée',
  description: 'La commande a vérifiée mais pas encore compilée',
  code: 1
},{
  title: 'compilée',
  description: 'La commande a été compilée',
  code: 2,
  name: 'compiled'
},{
  code: 3,
  name: 'received',
  title: 'reçu',
  description: 'La commande a été receptionnée' // but not yet paid !
},{
  code: 4,
  name: 'waiting',
  title: 'en attente',
  description: 'Le consommateur n\'est pas venu chercher sa commande, il a été invité de venir le chercher prochainement. Les produits de très court DLC doivent être retirés.'
},{
  code: 5,
  name: 'abandonned',
  title: 'abandonnée',
  description: 'Le consommateur n\'est pas venu chercher sa commande, après la compilation. Tous les produits périssables doivent être retirés, et les bocaux rajoutés à la boutique'
},{
  title: 'terminée',
  description: 'La commande a été collectée et payée par le consommateur',
  code: 6,
  name: 'done'
},{
  title: 'erreur',
  description: 'Il a eu un erreur avec cette commande',
  code: 7,
  name: 'error'
},{
  name: 'cancelled',
  title: 'annulée',
  description: 'La commande a été annulée avant la compilation',
  code: 8
},{
  name: 'merged',
  title: 'fusionnée',
  description: 'La commande a été fusionnée avec une autre commande',
  code: 9
}];